import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { v4 } from 'uuid';

var Callbacks = /*#__PURE__*/function () {
  function Callbacks() {
    _classCallCheck(this, Callbacks);

    _defineProperty(this, "callbacks", void 0);

    this.callbacks = {};
  }

  _createClass(Callbacks, [{
    key: "add",
    value: function add(callback) {
      var id = v4();
      this.callbacks[id] = callback;
      return id;
    }
  }, {
    key: "remove",
    value: function remove(id) {
      delete this.callbacks[id];
    }
  }, {
    key: "clean",
    value: function clean() {
      this.callbacks = {};
    }
  }, {
    key: "invoke",
    value: function invoke(id) {
      var callback = this.callbacks[id];

      if (typeof callback === 'function') {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        callback.apply(void 0, args);
      }
    }
  }]);

  return Callbacks;
}();

export default Callbacks;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/callbacks/lib/esm/Callbacks.js
// module id = 536
// module chunks = 0 1